import {actionTypes} from 'constants/constants';
import Api from 'api/apiMillionaire';

function update(data) {
	return {
		type: actionTypes.MILLIONAIRE_USER_INFO_UPDATE,
		data
	};
}
//异步action
function updateAsync(options) {
	return (dispatch,getState)=>{
		dispatch({
			type: actionTypes.MILLIONAIRE_USER_INFO_UPDATE,
			data: {
				status: 'FETCHING'
			}
		});
		Api.getUserInfo().then((res)=>{
			dispatch({
				type: actionTypes.MILLIONAIRE_USER_INFO_UPDATE,
				data: {
					status: 'FETCH_SUCCESS',
					data: res.result
				}
			});
			options && options.success && options.success(res);
		}).catch((res)=>{
			dispatch({
				type: actionTypes.MILLIONAIRE_USER_INFO_UPDATE,
				data: {
					status: 'FETCH_FAIL'
				}
			});
			options && options.fail && options.fail(res);
		});
	};
}
export default {
	update,
	updateAsync
};



// WEBPACK FOOTER //
// ./src/redux/actions/millionaire/userInfo.js